import { fetchHelper } from '@price-point/http-helpers';
import { getQueryParams } from 'shared/helpers';
import { setShowResetResultModal } from '../ui';

export default function onSubmitResetPassword(password) {
  return async (dispatch) => {
    const { token } = getQueryParams();
    try {
      await fetchHelper('na', 'POST', '/api/v1/oidc/changePassword', { token, password });
      dispatch(setShowResetResultModal('SUCCESS'));
    } catch (ex) {
      dispatch(setShowResetResultModal('FAIL'));
    }
  };
}
